import React, { FC, forwardRef } from 'react';
import { Formik, FormikProps } from 'formik';
import { Form } from 'formik-antd';
import { object } from 'yup';
import { FormikOnSubmit } from 'lib/formik.utils';
import {
  dateOfBirthValidationSchema,
  firstNameValidationSchema,
  genderValidationSchema,
  idNumberValidationSchema,
  lastNameValidationSchema,
  emailValidationSchema,
  phoneNumberValidationSchema,
  phoneNumberPrefixCodeValidation,
} from 'common/config/validationSchema';
import { defaultFormLayout } from 'common/config/formLayout';
import { BusinessPartnerPatientFormModel } from 'models/patient';
import { BusinessPartnerEditPatientFormItems } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/shared/BusinessPartnerEditPatientFormItems';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

export const businessPartnerPatientEmptyInitialValues: BusinessPartnerPatientFormModel = {
  firstName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',
  idNumberDocumentType: 'NON_REQUIRED',
  idNumber: '',
  email: '',
  phoneNumber: '',
  prefixCode: '',
  partner: '',
};

export interface BusinessPartnerRegisterPatientFormProps {
  onSubmit: FormikOnSubmit<BusinessPartnerPatientFormModel>;
  initialValues?: BusinessPartnerPatientFormModel;
  ref?: React.MutableRefObject<
    FormikProps<BusinessPartnerPatientFormModel> | any
  >;
}
export const BusinessPartnerPatientEditForm: FC<BusinessPartnerRegisterPatientFormProps> = forwardRef(
  ({ onSubmit, initialValues, children }, ref) => {
    const intlMessage = useFormatMessage();

    const businessPartnerPatientValidationSchema = object().shape(
      {
        firstName: firstNameValidationSchema(intlMessage),
        lastName: lastNameValidationSchema(intlMessage),
        dateOfBirth: dateOfBirthValidationSchema(intlMessage),
        gender: genderValidationSchema(intlMessage),
        idNumber: idNumberValidationSchema(intlMessage),
        email: emailValidationSchema(intlMessage),
        phoneNumber: phoneNumberValidationSchema(intlMessage),
        prefixCode: phoneNumberPrefixCodeValidation(intlMessage),
      },
      [['phoneNumber', 'prefixCode']]
    );

    return (
      <Formik
        validationSchema={businessPartnerPatientValidationSchema}
        initialValues={
          initialValues || businessPartnerPatientEmptyInitialValues
        }
        onSubmit={onSubmit}
        innerRef={ref}
      >
        <Form {...defaultFormLayout}>
          <BusinessPartnerEditPatientFormItems initialValues={initialValues} />
          {children}
        </Form>
      </Formik>
    );
  }
);
